import type { Id } from '@e-socna/data-layer';

type OptionGroup = Readonly<{ id: Id; label: string }>;

export type QuotationOptionsReminder = Readonly<{
  messages: readonly string[];
  severity: 'info' | 'warning';
  title?: string;
}>;

export const MISSING_OPTIONS_CHOICE_MESSAGE =
  "Aucun choix d'options n'est enregistré pour ce devis : toutes les options seront donc prises en compte en comptabilité.";

// Reminder of the quotation options chosen by the client on the accounting
// page; nothing to remind when the quotation has no option.
export const buildQuotationOptionsReminder = (
  optionGroups: readonly OptionGroup[],
  selectedOptionGroupIds: readonly Id[] | null | undefined,
): QuotationOptionsReminder | null => {
  if (!optionGroups.length) {
    return null;
  }

  if (!selectedOptionGroupIds) {
    return { messages: [MISSING_OPTIONS_CHOICE_MESSAGE], severity: 'warning' };
  }

  const chosenLabels = optionGroups
    .filter(({ id }) => selectedOptionGroupIds.includes(id))
    .map(({ label }) => label);

  return chosenLabels.length
    ? {
        messages: chosenLabels,
        severity: 'info',
        title: 'Options retenues par le client',
      }
    : {
        messages: ["Aucune option n'a été retenue par le client."],
        severity: 'info',
      };
};
